import { useTranslation } from 'react-i18next';

export const useTabs = () => {
  const { t } = useTranslation();

  return [
    { label: t('common.labels.details'), to: '../details' },
    { label: t('pages.channels.detail.tabs.analysis'), to: '../analysis' },
    { label: t('common.tabs.audit_logs'), to: '../audit-logs' },
  ];
};
